<template>
    <div class="column is-full">
        <h2 class="has-text-centered has-text-weight-semibold is-size-4">Info de contacto.</h2>
        <div class="card-content">
        <p>{{order.orderdata.firstName}} {{order.orderdata.lastName}}</p>
        <p>{{order.orderdata.email}}</p>
        <p><b>Tel:</b> {{order.orderdata.phoneNumber}}</p>
        <p><b>Documento:</b> {{order.orderdata.idNumber}} ({{order.orderdata.getIdTypeDisplay}})</p>

        <h2 class="has-text-centered has-text-weight-semibold is-size-4">Direccion.</h2>
        <p><b>Metodo:</b> {{order.orderdata.shipmentModelTitle}}</p>
        <p>{{order.orderdata.address}} - {{order.orderdata.number}} - {{order.orderdata.apNumber}}</p>
        <p>{{order.orderdata.location}}, <p>{{order.orderdata.region}}</p>
        <p>{{order.orderdata.zipCode}}</p>
        <p>{{order.orderdata.observations}}</p> 
        </div>
    </div>
    
</template>

<script>
export default {
    props:{
        order:{
            type:Object,
            default:new Object({})
        }
    },
    computed:{
        cotizacion(){
            return this.order.payment.amountUy / this.order.payment.amountUsd
        }
    }
}
</script>

<style lang="scss" scoped>
.card{
    border:0px #fff solid !important;
    
}

</style>